import {
  Directive,
  effect,
  HostListener,
  inject,
  Injector,
  input,
  OnDestroy,
  OnInit,
  signal,
  untracked,
} from '@angular/core';
import { NgControl } from '@angular/forms';
import { MatAutocomplete } from '@angular/material/autocomplete';

import { delay, noop, Subscription, tap } from 'rxjs';
import { isNil } from 'src/utils/utils';

@Directive({ selector: '[appResetInputMatAutocomplete]' })
export class ResetInputMatAutocompleteDirective implements OnInit, OnDestroy {
  private injector = inject(Injector);
  private control = inject(NgControl);

  previousSelectedControlValue = input<any>();
  matAutocomplete = input<MatAutocomplete>();

  previousSelectedControlValueMemory = signal(null);
  subscriptions: Subscription[] = [];

  @HostListener('focus') onFocus() {
    this.control?.control?.reset();
  }

  @HostListener('focusout') onFocusout() {
    const matAutocomplete = this.matAutocomplete();
    if (!matAutocomplete._isOpen || !matAutocomplete.showPanel) {
      const abstractControl = this.control.control;
      abstractControl.setValue(this.previousSelectedControlValue());
    }
  }

  constructor() {
    this.listenToPreviousSelectedControlValueChanges();
  }

  ngOnInit(): void {
    this.matAutocompleteClosedSubscription();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  private matAutocompleteClosedSubscription() {
    const matAutocomplete = this.matAutocomplete();
    const subscription = matAutocomplete.closed
      .asObservable()
      .pipe(
        delay(0),
        tap(() => {
          const matAutocomplete = this.matAutocomplete();
          if (!matAutocomplete._isOpen) {
            this.control?.control?.setValue(
              this.previousSelectedControlValue()
            );
          }
        })
      )
      .subscribe(noop);
    this.subscriptions.push(subscription);
  }

  listenToPreviousSelectedControlValueChanges() {
    effect(
      () => {
        const previousSelectedControlValue =
          this.previousSelectedControlValue();

        untracked(() => {
          if (!isNil(this.previousSelectedControlValueMemory())) {
            this.control?.control?.setValue(previousSelectedControlValue);
          }
          this.previousSelectedControlValueMemory.set(
            previousSelectedControlValue
          );
        });
      },
      { injector: this.injector }
    );
  }
}
